import { createApp } from 'vue';
import App from './App.vue';
import { loadConfig } from './config';
import './styles.css';

/**
 * Configuration has to be in place before anything renders: the sign-in screen
 * already needs the Cognito domain and client id.
 */
loadConfig()
  .then(() => createApp(App).mount('#app'))
  .catch((error: unknown) => {
    const message = error instanceof Error ? error.message : String(error);
    const root = document.querySelector('#app');
    if (root) {
      root.textContent = `Kon de app niet starten: ${message}`;
    }
  });
